import React from 'react'
import { connect } from 'react-redux'

import Sows from './Sows'

import { fetchSowsList, fetchTemplates } from './actions'


class SowsList extends React.Component {
    constructor(props) {
        super(props);
    }

    componentWillMount() {
        var _this = this

        setTimeout(function() {
            fetchSowsList.bind(_this)({
                user: _this.props.sows.user,
                admin: _this.props.sows.sowadmin
            })
        }, 2000)

        fetchTemplates.bind(this)()
    }

    render() {
        return (
            <Sows sowsList={this.props.sows.sowsList} />
        );
    }
}

const mapStateToProps = state => ({
    sows: state.sows
});

export default connect(mapStateToProps)(SowsList)
